import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { processForm } from "../../utils/processForm";
import { useTheme } from "../../context/ThemeContext";
import { StatusComp } from "../../components/shared/statusComp";

const SubscribeNewsletter = () => {
  const { peopleDomain, planetDomain, currentBrand, localeLanguage } =
    useTheme();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  const [status, setStatus] = useState("");

  const onSubmit = async (data) => {
    const formFields = {
      form_type: "newsletter_form",
      newsletter: "newsletter_signup",
      ...data
    };

    setStatus("processing");
    await processForm({
      formdata: formFields,
      peopleDomain,
      planetDomain,
      currentBrand,
      localeLanguage
    });

    setStatus("success");
    reset();
  };

  const expTexts = {
    processing: "Hang tight!",
    success: "Amazing!"
  };

  const statusTexts = {
    processing: "Your email will reach us soon...",
    success: "You are now subscribed to our weekly newsletter."
  };

  return (
    <div className="my-8">
      {!status ? (
        <form
          id={"newsletter"}
          className="w-full py-4 rounded-xxs"
          onSubmit={handleSubmit(onSubmit)}
        >
          <p className="text-xl planet:text-white planet:font-light planet:font-body text-black-lighter font-alice">
            Subscribe to our weekly newsletter
          </p>
          <input
            {...register("email_address", {
              required: true,
              pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
            })}
            placeholder="Enter your email address"
            className={` w-full py-2 pl-[17.5px] planet:bg-opacity-15  planet:bg-white mb-3 text-base text-black-lighter planet:text-white bg-transparent border-[.5px] focus:outline-0 rounded-xxs placeholder:text-base placeholder:font-bold placeholder:text-black-lighter planet:placeholder:text-white border-black-lighter planet:border-gray-testimonial md:w-full  ${
              errors.email_address ? " !border-red-600 " : ""
            }`}
          />
          <div className="mt-2 w-max button-submit">
            <button
              className="h6 flex justify-center items-center sm:py-2 sm:px-8 border-gray-darker !border-0 planet:gvi-bg-green bg-yellow-standard p-2 rounded-full planet:rounded-xxs w-full !text-white planet:!text-gray-darker !font-bold text-center"
              type="submit"
            >
              Subscribe
            </button>
          </div>
        </form>
      ) : (
        <div className="w-full py-5">
          <StatusComp
            expText={expTexts[status]}
            statusText={statusTexts[status]}
            status={status}
            align="center"
          />
        </div>
      )}
    </div>
  );
};

export default SubscribeNewsletter;
